import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayerPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.484 11.1249L12.462 6.12494C12.3139 6.04285 12.1474 5.99969 11.9781 5.99951C11.8088 5.99934 11.6422 6.04215 11.494 6.12394L2.51599 11.0839C2.35978 11.1702 2.22951 11.2967 2.13869 11.4504C2.04787 11.604 1.99982 11.7791 1.99951 11.9576C1.99921 12.136 2.04666 12.3113 2.13695 12.4652C2.22724 12.6192 2.35708 12.7461 2.51299 12.8329L11.535 17.8729C11.6835 17.9564 11.851 18.0003 12.0214 18.0005C12.1917 18.0007 12.3593 17.9571 12.508 17.8739L21.486 12.8739C21.6419 12.7872 21.7719 12.6603 21.8622 12.5064C21.9526 12.3526 22.0002 12.1773 22 11.9989C21.9998 11.8204 21.9518 11.6453 21.8611 11.4916C21.7703 11.3379 21.6401 11.2113 21.484 11.1249ZM12.023 15.8549L5.05899 11.9649L11.976 8.14294L18.94 12.0019L12.023 15.8549Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 22C12.1698 22.0001 12.3367 21.9567 12.485 21.874L21.485 16.874L20.514 15.126L12 19.856L3.48498 15.126L2.51398 16.874L11.514 21.874C11.6626 21.9566 11.8299 22 12 22ZM20 2H18V4H16V6H18V8H20V6H22V4H20V2Z",
		fill: "black"
	})]
});
export default SvgLayerPlus;
